import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
const popupBodyIsPhoneCss = "peyrj7g";
const popupBodyBottomBorderCss = "p5hpjtm";
const popupBodyCss = "p18l1tgj";
export const PopupBody = forwardRef((props, ref) => {
  const {
    bottomBorder,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(popupBodyCss, {
    [popupBodyIsPhoneCss]: isPhone,
    [popupBodyBottomBorderCss]: bottomBorder
  }, props.className)} />;
});

require("./popup_body.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./popup_body.js");